import React, { useContext } from "react";
import PropTypes from "prop-types";
import context from "components/Shared/MSidebar/utility/context";

const DrawerItemIcon = ({
  icon,
  iconOnClick,
  title,
}) => {
  const { open } = useContext(context);

  return (
    <div
      className="DrawerItemIcon-Root"
      onClick={iconOnClick}
    >
      <i 
        title={!open ? title : ""}
        className="material-icons"
      >
        {icon}
      </i>
    </div>
  );
};

DrawerItemIcon.defaultProps = {
  iconOnClick: () => {},
};

DrawerItemIcon.propTypes = {
  isCurrentPath: PropTypes.bool,
  icon: PropTypes.string,
  title: PropTypes.string,
  iconOnClick: PropTypes.func,
};

export default DrawerItemIcon;